import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const ManageContentFacadeTypes = ({ location }) => {
  const [contentFacadeTypeCodes, setContentFacadeTypeCodes] = useState([]);
  let parms = new URLSearchParams(location.search);
  const [message, setMessage] = useState("");
  const {token,userMetadata}=useAuth()
  const navigate = useNavigate();
  const [state, setState] = useState({
    contentFacadeTypeId: parseInt(parms.get("id")),
    contentFacadeTypeValueCode: 0,
    contentFacadeTypeDescr: "",
    contentFacadeTypeCdata: "",
    contentFacadeTypeBdata: "",
    securityContextId: 0,
    createUser: 0,
    createDate: new Date().toISOString(),
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
  });
  useEffect(() => {
    handleOnLoad();
  }, []);

  function handleSave(event) {
    console.log("handling save 1");

    event.preventDefault();
    console.log("handling save");

    var url = `${globalConfig.apiDatahubUrl}/content-facade-types/${state.contentFacadeTypeId}`;

    axios
      .patch(url, state, apiHeader(token))
      .then((response) => {
        console.log("response.data");
        console.log(response.status + ":" + response.data.contentInputSourceId);

        if (response.status === 200) {
          setMessage("Success");
          setInterval(() => {
            window.location.reload();
          }, 1000);
        } else {
          setMessage("Failed");
        }
        console.log(message);
        event.preventDefault();
      })
      .catch((err) => {
        console.log("error - " + err);
      });
    console.log("message info - " + message);
  }
  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.systemCodesUrl}/CONTENT_FACADE_TYPE`,
        apiHeader(token)
      )
      .then((res) => {
        const contentIndexTypeCodes = res.data;
        console.log("results", contentIndexTypeCodes);
        setContentFacadeTypeCodes(contentIndexTypeCodes);
      })
      .catch((err) => {
        console.log("here");
        console.log(err);
      });

    console.log("handleOnLoad() - loading id = " + state.contentFacadeTypeId);
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-facade-types/${state.contentFacadeTypeId}`,
        apiHeader(token)
      )
      .then((res) => {
        const contentType = res.data;
        console.log("contentType");
        console.log(contentType);
        setState(contentType);
        console.log("state");
        console.log(state);
      });
  };

  function onDelete() {
    let deleteID = state.contentFacadeTypeId;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-facade-types/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        navigate(-1);
      })
      .catch((err) => console.log("Err delete:" + err));
  }
  return (
    <form>
      <div className="container-fluid">
      <button
          type="button"
          className="btn btn btn-outline-secondary mt-2 mb-3"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>
        <h4>Manage Content Facade Types</h4>
        <hr />
        <h4>Selector</h4>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Facade Type Selector "
          >
            Content Facade Type Selector
          </label>
          <select
            id="contentFacadeTypeId"
            onchange="submit()"
            className="form-control input-xlarge col-sm-8"
            valueChangeListener="#{ombContentFacadeTypeForm.get }"
          >
            <option value="#{ombContentFacadeTypeForm.contentFacadeTypeSelectList}" />
          </select>
        </div>
        <hr />
        <h4>Content Facade Type Details</h4>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Facade Type Id"
          >
            Content Facade Type Id
          </label>
          <input
            className="form-control input-xlarge col-sm-8"
            readOnly={true}
            value={state.contentFacadeTypeId}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Facade Type Value Code"
          >
            Content Facade Type Value Code
          </label>
          <select
            id="contentFacadeTypeValueCode"
            onChange={handleChange}
            className="form-control input-xlarge col-sm-8"
            value={state.contentFacadeTypeValueCode}
          >
            <option value={0}>Select Facade Type Value Code </option>
            {contentFacadeTypeCodes.map(
              ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                <option key={systemCodeValueId} value={systemCodeValueId}>
                  {systemCodeValueValue}{" "}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Facade Type Description"
          >
            Content Facade Type Description
          </label>
          <textarea
            id="contentFacadeTypeDescr"
            className="form-control input-xlarge col-sm-8"
            value={state.contentFacadeTypeDescr}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Facade Type CData"
          >
            Content Facade Type CData
          </label>
          <textarea
            id="contentFacadeTypeCdata"
            className="form-control input-xlarge col-sm-8"
            onChange={handleChange}
            className="form-control input-xlarge col-sm-8"
            value={state.contentFacadeTypeCdata}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Facade Type BData"
          >
            Content Facade Type BData
          </label>
          <textarea
            id="contentFacadeTypeBdata"
            className="form-control input-xlarge col-sm-8"
            readOnly={true}
            onChange={handleChange}
            className="form-control input-xlarge col-sm-8"
            value={state.contentFacadeTypeBdata}
          />
        </div>
        <hr />
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Last Updated By #{ombUserSession.getUserNameForId(contentTemplateForm.currentContentTemplate.lastUpdateUser)} on "
          >
            Last Updated By
          </label>
          <input
            className="form-control col-sm-1"
            readonly="readonly"
            value={state.lastUpdateUser}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            
          >
            Last Update Date
          </label>
          <input
            className="form-control col-sm-8"
            readonly="readonly"
            value={state.lastUpdateDate.slice(0, 16)}
            type="datetime-local"
          />
        </div>
        <hr />
        <button
          className="btn btn-danger"
          value="Delete"
          onClick={onDelete}
        >
          Delete
        </button>
        &nbsp;

        <button className="btn btn-success" value="Save" onClick={handleSave}>
          Save
        </button>
        &nbsp;
        {/* <button
          className="btn btn-primary"
          value="Clear"
          actionListener="#{ombContentFacadeTypeForm.clear}"
        >
          Clear
        </button> */}
      </div>
    </form>
  );
};

export default ManageContentFacadeTypes;
